export default "__VITE_ASSET__DHK2I4Ob__"